import { useGetDataDumpsQuery } from '@/app/services/nucleus';
import { Box, Flex, Spinner } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import Layout from '../common/Layout';
import AlertComponent from '../common/AlertComponent';
import { Outlet } from 'react-router-dom';

const DataDump = () => {
  const [errorTitle, setErrorTitle] = useState('');
  const [errorDesc, setErrorDesc] = useState('');
  const { isError, error: dataDumpError, isLoading } = useGetDataDumpsQuery();

  useEffect(() => {
    if (isError) {
      setErrorTitle('Data Dump Error');
      setErrorDesc(dataDumpError?.data?.detail);
    }
  }, [isError]);

  return (
    <Box data-test-id="data-dump">
      <Layout pageTitle={'Pact'}>
        {isLoading ? (
          <Flex alignItems="center" justifyContent="center" py={200}>
            <Spinner color="brand.900" size="lg" />
          </Flex>
        ) : isError ? (
          <AlertComponent status="warning" title={errorTitle} description={errorDesc} />
        ) : (
          <Outlet />
        )}
      </Layout>
    </Box>
  );
};

export default DataDump;
